import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { MyStore, connect } from 'kts-platform-frame/redux';
import ReduxState, { IUser } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import TotalModulesAction from '../Modules.Action';
import modulesRoute from './Modules.Route';
import UIMenu from './UI.MenuNew';
import UIHeader from './UI.Header';
import UIAppBox from 'src/display/apps/AppSearch';
import { Button, Layout } from 'antd';
import AppSdk from 'kts-platform-frame/appSdk';
import { Aside } from 'kts-platform-frame/display/part';

const css = require('./index.scss');
const { Header, Sider, Content } = Layout;

/** Redux接口 */
interface IReduxStatePart {
    user: IUser;
    loginType: "silent" | "default";
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 操作台 2.0 */
@connect((state: ReduxState): IReduxStatePart => ({
    user: state.user,
    loginType: state.system.loginType,
}))
export default class Workbench2 extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {

        const { user } = MyStore.instance.getState();
        if (user.cToken) {
            this.init();
        }

        if (this.props.location.pathname === '/workbench/platform/network/userlist') {
            this.setState({
                runAppKeying: 'Kingxunlian.Network'
            });
        } else if (this.props.location.pathname === '/workbench/appSearch') {
            this.setState({
                runAppKeying: 'myAppBox'
            });
        }
    }

    init = async () => {
        // 判断是否展示新手引导
        // const guideVersionBol = await TotalModulesAction.getCurrentGuideVersion();
        // if (guideVersionBol && this.props.loginType !== 'silent') {
        // this.props.history.push(`/gettingStarted`);
        // } else {
        ModulesAction.queryMenuMode();
        ModulesAction.updateAppList();
        AppSdk.instance.onEvent('myAppChangeEvent', ModulesAction.updateAppList);
        // }
    }

    componentDidUpdate() {
        AppSdk.instance.onEvent('myAppChangeEvent', ModulesAction.updateAppList);
    }

    componentWillUnmount() {
        AppSdk.instance.offEvent('myAppChangeEvent', ModulesAction.updateAppList);
    }

    render() {
        if (this.redirection() === false) {
            return null;
        }
        return (
            <ModulesRoot action={ModulesAction}>
                {/* <div >
                    <Button
                        onClick={async () => {
                            const appResource = await AppSdk.instance.getAppResource('Kingxunlian.FapiaoOutputCollection');
                        }}
                    >
                        测试
                    </Button>
                </div> */}
                <Layout className={css.layout} >
                    {
                        window['$$_self'] === 'iframe' ?
                            <div className={css.content} style={{ margin: '0px' }}>
                                {modulesRoute()}
                            </div> :
                            <>
                                <Header className={css.header} >
                                    <UIHeader />
                                </Header>
                                <Layout>
                                    <Sider
                                        className={css.sider}
                                        collapsedWidth={50}
                                        width={180}
                                        collapsed={this.state.collapsed}
                                    >
                                        <div style={{ display: 'flex', height: '100%', position: 'relative' }}>
                                            <UIMenu />
                                        </div>
                                    </Sider>
                                    <Content>
                                        {this.state.appBoxShow &&
                                            <div className={this.state.forceShowMenu ? `${css.appBox} ${css.appBoxLong}` : css.appBox} >
                                                <UIAppBox updateVisible={ModulesAction.setAppBoxVisible} />
                                            </div>
                                        }
                                        <div className={this.state.forceShowMenu ? `${css.content} ${css.mL245}` : css.content} >
                                            {modulesRoute()}
                                        </div>
                                    </Content>
                                    <Aside />
                                </Layout>
                            </>
                    }
                </Layout>
            </ModulesRoot>
        );
    }

    /** 根据登录状态跳转 */
    private redirection = (): boolean => {
        const { history, user } = this.props;
        if (!user.cToken) {
            if (window.location.href) {
                history.push(`/login?redirectURL=${escape(window.location.pathname + window.location.search + window.location.hash)}`);
            } else {
                history.push(`/login`);
            }
            return false;
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench2/index.tsx